import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = { class: "relative bg-white rounded-lg shadow dark:bg-gray-700" };
const _hoisted_3 = {
    class: "flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600",
    "data-testid": "confirm-modal-header"
};
const _hoisted_4 = {
    id: "confirm-modal-title",
    class: "flex items-center text-lg font-semibold text-gray-900 dark:text-white",
    "data-testid": "confirm-modal-title"
};
const _hoisted_5 = {
    class: "p-4 md:p-5 space-y-4",
    "data-testid": "confirm-modal-body"
};
const _hoisted_6 = {
    id: "confirm-modal-message",
    class: "text-base leading-relaxed text-gray-500 dark:text-gray-400",
    "data-testid": "confirm-modal-message"
};
const _hoisted_7 = {
    class: "flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600",
    "data-testid": "confirm-modal-footer"
};
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfirmModal',
    props: {
        isVisible: { type: Boolean },
        title: {},
        message: {},
        confirmText: { default: "Confirm" },
        cancelText: { default: "Cancel" },
        type: { default: "warning" },
        showCloseButton: { type: Boolean, default: true },
        showCancelButton: { type: Boolean, default: true },
        closeOnBackdrop: { type: Boolean, default: true },
        testId: { default: "confirm-modal" }
    },
    emits: ["confirm", "cancel", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const iconClass = computed(() => {
            switch (props.type) {
                case "error":
                    return "ri-error-warning-line text-red-500";
                case "warning":
                    return "ri-error-warning-line text-yellow-500";
                case "success":
                    return "ri-checkbox-circle-line text-green-500";
                case "info":
                    return "ri-information-line text-blue-500";
                default:
                    return "ri-error-warning-line text-yellow-500";
            }
        });
        const confirmButtonClass = computed(() => {
            switch (props.type) {
                case "error":
                case "warning":
                    return "text-white bg-red-700 hover:bg-red-800 focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800";
                case "success":
                    return "text-white bg-green-700 hover:bg-green-800 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800";
                case "info":
                    return "text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800";
                default:
                    return "text-white bg-red-700 hover:bg-red-800 focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800";
            }
        });
        const handleConfirm = () => {
            emit("confirm");
            emit("close");
        };
        const handleCancel = () => {
            emit("cancel");
            emit("close");
        };
        const handleBackdropClick = () => {
            if (props.closeOnBackdrop) {
                handleCancel();
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, { name: "modal" }, {
                    default: _withCtx(() => [
                        (__props.isVisible)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none",
                                "data-testid": "confirm-modal-backdrop",
                                onClick: handleBackdropClick
                            }, [
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "fixed inset-0 bg-black opacity-50" }, null, -1 /* CACHED */)),
                                _createElementVNode("div", {
                                    class: "relative w-full max-w-md max-h-full",
                                    "data-testid": __props.testId,
                                    role: "dialog",
                                    "aria-modal": "true",
                                    "aria-labelledby": "confirm-modal-title",
                                    "aria-describedby": "confirm-modal-message",
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("h2", _hoisted_4, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass([[iconClass.value, 'mr-2'], "text-2xl"]),
                                                    "aria-hidden": "true"
                                                }, null, 2 /* CLASS */),
                                                _createTextVNode(" " + _toDisplayString(__props.title), 1 /* TEXT */)
                                            ]),
                                            (__props.showCloseButton)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500",
                                                    "aria-label": "Fermer la fenêtre",
                                                    onClick: handleCancel
                                                }, [...(_cache[1] || (_cache[1] = [
                                                        _createElementVNode("svg", {
                                                            class: "w-3 h-3",
                                                            "aria-hidden": "true",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            fill: "none",
                                                            viewBox: "0 0 14 14"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                stroke: "currentColor",
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                "stroke-width": "2",
                                                                d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                                            })
                                                        ], -1 /* CACHED */),
                                                        _createElementVNode("span", { class: "sr-only" }, "Close modal", -1 /* CACHED */)
                                                    ]))]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.message), 1 /* TEXT */),
                                            _renderSlot(_ctx.$slots, "default")
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: _normalizeClass([confirmButtonClass.value, "font-medium rounded-lg text-sm px-5 py-2.5 text-center focus:ring-4 focus:outline-none"]),
                                                "data-testid": "confirm-modal-confirm-button",
                                                onClick: handleConfirm
                                            }, _toDisplayString(__props.confirmText), 3 /* TEXT, CLASS */),
                                            (__props.showCancelButton)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                                                    "data-testid": "confirm-modal-cancel-button",
                                                    onClick: handleCancel
                                                }, _toDisplayString(__props.cancelText), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ], 8 /* PROPS */, _hoisted_1)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 3 /* FORWARDED */
                })
            ]));
        };
    }
});
